import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TrailingSlashGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const url: string = state.url;
    const [pathAndQuery, urlFragment] = url.split('#');
    const [urlPathWithNoQueryStrings, urlQueryString] = pathAndQuery.split('?');

    const isPathValid = urlPathWithNoQueryStrings.endsWith('/');
    const isGuardBypassed = route.data?.['noTrailingSlashGuard'];
    const isFragmentAlreadyHandled = urlFragment && urlPathWithNoQueryStrings.endsWith('/');

    if (isPathValid || isGuardBypassed || isFragmentAlreadyHandled) {
      return true;
    }

    // Format query string and fragment
    const queryParams = new URLSearchParams(urlQueryString);
    queryParams.delete('returnUrl');
    const queryStringParams = queryParams.toString() ? `?${queryParams.toString()}` : '';
    const fragmentString = urlFragment ? `#${urlFragment.replace(/\/$/, '')}` : '';

    // Construct the formatted URL
    const urlFormatted = `${urlPathWithNoQueryStrings}/${queryStringParams}${fragmentString}`;

    // Redirect to the formatted URL
    this.router.navigateByUrl(urlFormatted, { replaceUrl: true, state: { noTrailingSlashGuard: true } });

    return false;
  }
}
